import { Slot as e } from "@radix-ui/react-slot";
import { useComposedRefs as r } from "@radix-ui/react-compose-refs";
import { createContextScope as t } from "@radix-ui/react-context";
import o from "react";
export function createCollection(c) {
  const n = c + "CollectionProvider",
    [l, i] = t(n),
    [f, a] = l(n, {
      collectionRef: {
        current: null
      },
      itemMap: new Map()
    }),
    u = e => {
      const {
          scope: r,
          children: t
        } = e,
        c = o.useRef(null),
        n = o.useRef(new Map()).current; /*#__PURE__*/
      return o.createElement(f, {
        scope: r,
        itemMap: n,
        collectionRef: c
      }, t);
    },
    m = c + "CollectionSlot",
    s = /*#__PURE__*/o.forwardRef((t, c) => {
      const {
          scope: n,
          children: l
        } = t,
        i = a(m, n),
        f = r(c, i.collectionRef); /*#__PURE__*/
      return o.createElement(e, {
        ref: f
      }, l);
    }),
    p = c + "CollectionItemSlot",
    d = "data-radix-collection-item",
    R = /*#__PURE__*/o.forwardRef((t, c) => {
      const {
          scope: n,
          children: l,
          ...i
        } = t,
        f = o.useRef(null),
        u = r(c, f),
        m = a(p, n);
      return o.useEffect(() => (m.itemMap.set(f, {
        ref: f,
        ...i
      }), () => {
        m.itemMap.delete(f);
      })), /*#__PURE__*/o.createElement(e, {
        [d]: "",
        ref: u
      }, l);
    });
  return [{
    Provider: u,
    Slot: s,
    ItemSlot: R
  }, function (e) {
    const r = a(c + "CollectionConsumer", e);
    return o.useCallback(() => {
      const e = r.collectionRef.current;
      if (!e) return [];
      const t = Array.from(e.querySelectorAll("[".concat(d, "]")));
      return Array.from(r.itemMap.values()).sort((e, r) => t.indexOf(e.ref.current) - t.indexOf(r.ref.current));
    }, [r.collectionRef, r.itemMap]);
  }, i];
}